import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const scenarios = api(async function scenarios({ skip, take, search, sort, descending }) {
    return query(
        gql`
            query GetScenarios($skip: Int, $take: Int, $search: String, $sort: ScenarioSort, $descending: Boolean) {
                scenarios(skip: $skip, take: $take, search: $search, sort: $sort, descending: $descending) {
                    totalCount
                    items {
                        id
                        name
                        regimeId
                        regimeName
                        rateCardId
                        rateCardName
                        rateCardCurrency
                        facilitiesCount
                        assetsCount
                        annualCost
                        status
                        created
                        modified
                        variantCount
                        variants {
                            id
                            name
                            rateCardId
                            rateCardName
                            rateCardCurrency
                            status
                            annualCost
                        }
                    }
                }
            }
        `,
        { skip, take, search, sort, descending },
        { returns: "scenarios" }
    )
})

export const scenario = api(async function scenario({ id }) {
    return query(
        gql`
            query GetScenario($id: String!) {
                scenario(id: $id) {
                    id
                    name
                    regimeId
                    regimeName
                    rateCardId
                    rateCardName
                    rateCardCurrency
                    rateCardIsArchived
                    rateCardSkillMapName
                    ruleSetId
                    ruleSetName
                    isStale
                    status
                    costResult
                    calculatedAt
                    created
                    modified
                    variantCount
                    variants {
                        id
                        name
                        rateCardId
                        rateCardName
                        rateCardCurrency
                        rateCardIsArchived
                        rateCardSkillMapName
                        ruleSetId
                        ruleSetIds
                        ruleSetName
                        ruleSetNames
                        scenarioRuleSetId
                        disabledModifierIds
                        rateCardModifiers {
                            id
                            name
                            type
                            scope {
                                kind
                                value
                            }
                            value
                            applyTo
                        }
                        rateCardIsDeleted
                        ruleSetIsDeleted
                        status
                        costResult
                        calculatedAt
                        isStale
                        annualCost
                        lastCalculationError
                    }
                }
            }
        `,
        { id },
        { returns: "scenario" }
    )
})
